import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './tabs-faqs.component.scss';
import * as $ from 'jquery';
var TabsFaqs = /** @class */ (function (_super) {
    tslib_1.__extends(TabsFaqs, _super);
    function TabsFaqs(element) {
        var _this = _super.call(this, element) || this;
        _this.autoHeight = 'true';
        return _this;
    }
    TabsFaqs.prototype.init = function () {
        var _this = this;
        if (this.element.getAttribute('data-autoheight')) {
            this.autoHeight = this.element.getAttribute('data-autoheight').toString();
        }
        this.tabComponent = $(this.element);
        this.tabsContent = Array.from(this.tabComponent.find('.tabs-faqs__item-content'));
        setTimeout(function () {
            _this.equalHeights();
        }, 100);
        this.initTabs();
        this.dropdown = this.element.querySelector('.js-option-selector');
        this.slideRunner = this.tabComponent.find('.tabs-faqs__slide-runner');
        this.tabTriggers = Array.from(this.tabComponent.find('.js-tab-trigger'));
        this.activeTabTrigger = this.tabComponent.find('.tabs-faqs__item--active');
        this.activeTab = this.tabComponent.find('.tabs-faqs__item-content--active');
        $(document).ready(function () {
            _this.moveSlideRunner();
        });
    };
    TabsFaqs.prototype.bindEvents = function () {
        var _this = this;
        this.tabTriggers.map(function (item) { return item.addEventListener('click', function (event) {
            _this.toggleTabs(event);
            _this.moveSlideRunner();
        }); });
        window.addEventListener('resize', this.debounce(function () {
            _this.moveSlideRunner();
        }, 250, false));
        window.addEventListener('resize', this.onResize.bind(this));
        this.dropdown.addEventListener('change', function (event) {
            var element = event.target;
            var index = element.selectedIndex;
            var value = element.value;
            _this.dropdownSelection(value, index);
        });
    };
    TabsFaqs.prototype.onResize = function () {
        var _this = this;
        setTimeout(function () {
            _this.equalHeights();
        }, 100);
    };
    TabsFaqs.prototype.initTabs = function () {
        var tabs = this.tabComponent.find('.tabs-faqs__item');
        var tabsContent = this.tabsContent;
        for (var i = 0; i < tabs.length; i++) {
            var tabGuid = this.generateGuid();
            $(tabs[i]).attr('data-target', "tabs-faqs__item-" + tabGuid);
            $(tabsContent[i]).attr('id', "tabs-faqs__item-" + tabGuid);
        }
    };
    TabsFaqs.prototype.equalHeights = function () {
        if (this.autoHeight == 'true') {
            var elements = this.tabsContent;
            for (var i = 0; i < elements.length; i++) {
                elements[i].style.height = 'auto';
            }
            // if (MediaQueryService.getMediaQuery() !== 'small' && MediaQueryService.getMediaQuery() !== 'x-small') {
            //     let tallestElement = 0;
            //     for (let i = 0; i < elements.length; i++) {
            //         let el = elements[i];
            //         let elHeight = el.offsetHeight;
            //         if (elHeight > tallestElement) {
            //             tallestElement = elHeight;
            //         }
            //     }
            //     for (let i = 0; i < elements.length; i++) {
            //         elements[i].style.height = `${tallestElement}px`;
            //         if (!elements[i].classList.contains('tabs-faqs__item-content--active')) {
            //             elements[i].style.height = '0';
            //         }
            //     }
            // }
        }
    };
    TabsFaqs.prototype.toggleTabs = function (event) {
        if (!$(event.currentTarget).hasClass('tabs-faqs__item--active')) {
            this.closeTab();
            this.activeTabTrigger = $(event.currentTarget);
            this.activeTab = this.tabComponent.find("#" + this.activeTabTrigger.attr('data-target'));
            this.openTab();
        }
        this.equalHeights();
    };
    TabsFaqs.prototype.moveSlideRunner = function () {
        var tabPositionLeft = this.activeTabTrigger.position().left;
        var tabWidth = this.activeTabTrigger.width();
        this.slideRunner
            .width(0)
            .css('left', tabPositionLeft + "px")
            .show()
            .delay(350)
            .width(tabWidth);
    };
    TabsFaqs.prototype.generateGuid = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
    TabsFaqs.prototype.closeTab = function () {
        this.activeTabTrigger.removeClass('tabs-faqs__item--active');
        this.activeTab.removeClass('tabs-faqs__item-content--active');
    };
    TabsFaqs.prototype.openTab = function () {
        this.activeTabTrigger.addClass('tabs-faqs__item--active');
        this.activeTab.addClass('tabs-faqs__item-content--active');
    };
    TabsFaqs.prototype.debounce = function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate)
                    func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow)
                func.apply(context, args);
        };
    };
    TabsFaqs.prototype.dropdownSelection = function (value, index) {
        if (index == 0) {
            index = 4;
        }
        if (index && value) {
            if (index == 4) {
                index = 0;
            }
            this.tabsContent.map(function (item, indexContent) {
                item.classList.remove('tabs-faqs__item-content--active');
                item.style.height = '0';
                if (indexContent === index) {
                    item.classList.add('tabs-faqs__item-content--active');
                    item.style.height = 'auto';
                }
            });
            this.tabTriggers.map(function (item, indexTabItem) {
                item.classList.remove('tabs-faqs__item--active');
                if (indexTabItem === index) {
                    item.classList.add('tabs-faqs__item--active');
                }
            });
        }
    };
    return TabsFaqs;
}(Base));
export { TabsFaqs };



//////////////////
// WEBPACK FOOTER
// ./components/tabs-faqs/tabs-faqs.component.ts
// module id = 536
// module chunks = 0